module.exports = __webpack_public_path__ + "static/OklahomaStandard-Badge-Blue-3ad48e58674d25351ff13ddf6af4d46a.svg";